import { IconButton, Stack, styled, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useNavigate } from 'react-router-dom'
import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { HeaderWrapper } from '../../../components/Wrapper/HeaderWrapper'
import ArrowLeftIcon from './../../../assets/icons/ArrowLeft.svg?react'
import ReferralLinkInput from './components/ReferralLinkInput'
import ReferralProgramStatistics from './components/ReferralProgramStatistics'
import ReferralProgramSteps from './components/ReferralProgramSteps'
import ReferralTable from './components/ReferralTable'

const InnerWrapper = styled(Grid)(({ theme }) => ({
    padding: '32px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    width: '810px',
    [theme.breakpoints.down('lg')]: {
        width: '100%',
    },
    [theme.breakpoints.down('md')]: {
        padding: '24px 16px',
    },
}))

const StyledBlockWrapper = styled(BlockWrapper)(({ theme }) => ({
    height: '100%',
}))

const ReferralProgramPage = () => {
    const navigate = useNavigate()

    return (
        <StyledBlockWrapper>
            <HeaderWrapper>
                <Stack direction="row" sx={{ alignItems: 'center', gap: '8px' }}>
                    <IconButton
                        sx={{
                            backgroundColor: '#F9FAFB',
                        }}
                        color="primary"
                        onClick={() => {
                            navigate(-1)
                        }}>
                        <ArrowLeftIcon />
                    </IconButton>
                    <Typography variant="h4">Реферальная программа</Typography>
                </Stack>
            </HeaderWrapper>
            <InnerWrapper>
                <ReferralProgramStatistics />
                <ReferralLinkInput
                    fullWidth
                    sx={{
                        borderRadius: '100px',
                        marginTop: '20px',
                        background: '#ffffff',
                        '& .MuiInputBase-root': {
                            backgroundColor: '#ffffff',
                        },
                    }}
                />
                <ReferralProgramSteps />
                <ReferralTable />
            </InnerWrapper>
        </StyledBlockWrapper>
    )
}

export default ReferralProgramPage
